import { Box, BoxProps, Button, Skeleton } from "@mui/material";
import * as React from "react";
import EditLocationAltOutlinedIcon from "@mui/icons-material/EditLocationAltOutlined";
import { LocationDialog, LocationSummary } from "./LocationDialog";
import { useLanguage } from "./Language";
import { BranchLimit, useBranchLimits } from "./BranchLimits";

export interface BranchLimitControlProps extends BoxProps {
  onChangeBranchLimits?: (
    newBranchIdentifiers: BranchLimit["identifier"][]
  ) => void;
}

export const BranchLimitControl: React.FC<BranchLimitControlProps> = ({
  onChangeBranchLimits = () => {},
  ...props
}) => {
  const {
    branchLimits,
    selectedBranchIds,
    updateSelectedBranches,
    displayBranchLimitControl,
  } = useBranchLimits();

  const { translate } = useLanguage();

  const onClickEditLocations = () => {
    setLocationDialogOpen(true);
  };

  const [locationDialogOpen, setLocationDialogOpen] =
    React.useState<boolean>(false);

  return (
    <React.Fragment>
      {displayBranchLimitControl && (
        <Box {...props}>
          {branchLimits && (
            <Button
              startIcon={<EditLocationAltOutlinedIcon />}
              onClick={onClickEditLocations}
            >
              <LocationSummary
                prefixText={translate("searching")}
                branchLimits={branchLimits}
                selected={selectedBranchIds}
              ></LocationSummary>
            </Button>
          )}
          {!branchLimits && (
            <Skeleton height={"36.5px"}>
              <Button></Button>
            </Skeleton>
          )}
          {branchLimits && (
            <LocationDialog
              branchLimits={branchLimits}
              open={locationDialogOpen}
              selected={selectedBranchIds}
              onSubmit={(data) => {
                updateSelectedBranches([...data]);
                onChangeBranchLimits([...data]);
                setLocationDialogOpen(false);
              }}
              onClose={() => {
                setLocationDialogOpen(false);
              }}
            ></LocationDialog>
          )}
        </Box>
      )}
    </React.Fragment>
  );
};
